"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var BigNumberRangeValidator_1 = require("../../../core/model/data-dictionary/validators/BigNumberRangeValidator");

var ConstraintTypeEnum_1 = require("./ConstraintTypeEnum");

var SimpleConstraint_1 = require("./SimpleConstraint");
/**
 * The rule set minimum for price based on promotion price. It is x % above promotion price
 * (both historical and scheduled promotions are considered).
 *
 * @author RV
 */


var AbovePromotion =
/*#__PURE__*/
function (_SimpleConstraint_1$S) {
  _inherits(AbovePromotion, _SimpleConstraint_1$S);

  /**
   * @param value
   */
  function AbovePromotion(value) {
    var _this;

    _classCallCheck(this, AbovePromotion);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AbovePromotion).call(this, value));
    _this.value = value;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(AbovePromotion, [{
    key: "getType",
    value: function getType() {
      return ConstraintTypeEnum_1.ConstraintTypeEnum.AbovePromotion;
    }
  }]);

  return AbovePromotion;
}(SimpleConstraint_1.SimpleConstraint);

exports.AbovePromotion = AbovePromotion;
AbovePromotion.MIN_VALUE = 0;
AbovePromotion.MAX_VALUE = 10000000; // tslint:disable-next-line:member-ordering

AbovePromotion.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SimpleConstraint_1.SimpleConstraint.name);
  return {
    value: builder.bigNum('value', new BigNumberRangeValidator_1.BigNumberRangeValidator(AbovePromotion.MIN_VALUE, AbovePromotion.MAX_VALUE))
  };
}();